
import {Component, Prop, Vue} from "vue-property-decorator";
import RightsForm from "@/components/rights/RightsForm.vue";
import { Getter } from "vuex-class";
import { canEditUserRights } from "@/services/rights";

@Component({
  components: { RightsForm },
})
export default class EditUserRights extends Vue {

    get canEditCurrentUserRights(): boolean {
      const targetRole = this.user.ManagersRelations ? "MANAGERS" : "GUESTS";
      return canEditUserRights(this.currentUser, targetRole, this.user.id);
    }

    @Prop({default: {}})
    public user: any;

    @Prop({default: false})
    public canEditProfile: boolean;

    @Prop({default: false})
    public isMobile: boolean;

    @Prop({default: null})
    public companyId: number;

    public $refs!: {
      rightsForm: any,
    };

    @Getter private currentUser: any;

    private isEdit: boolean = false;
    private valid: boolean = true;
    private loading: boolean = false;
    private rights: any[] = [];
    private userRights: any[] = [];

    private mounted(): void {
      if (this.canEditCurrentUserRights) {
        this.getRights();
        this.getUserRights();
      }
    }

    private closeEdit(): void {
        this.isEdit = false;
    }

    private save(): Promise<any> {
        this.loading = true;
        const rightsToSave = this.$refs.rightsForm.currentRights
          .filter((r) => r.isChecked).map((r) => r.id);
        return this.$store.dispatch("rights/saveUserRights", {
            userId: this.user.id,
            companyId: this.companyId,
            rights: rightsToSave,
        }).then((res) => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("actions.saved"),
            });
            this.closeEdit();
            this.getUserRights();
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err?.response?.data?.error || err,
            });
        }).finally(() => this.loading = false);
    }

    private async getRights(): Promise<any> {
      this.rights = await this.$store.dispatch("rights/getAllRights")
        .then((res) => res.rights);
    }

    private async getUserRights(): Promise<void> {
      this.userRights = await this.$store.dispatch("rights/getUserRightsById", {
        userId: this.user.id,
        companyId: this.companyId,
      }).then((userRights) => userRights.rights);
    }
}
